var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ImageAsDataUrlRenderer',{attrs:{"alt":_vm.id,"classes":{ 'gloss-media-image': true },"url":_vm.source}})
}
var staticRenderFns = []

export { render, staticRenderFns }